import React from 'react';
import PropTypes from 'prop-types';

const ButtonDefaultLink = (
  {
    ariaLabel,
    children,
    className,
    classNameCustom,
    disabled,
    icon,
    onClick,
    style = {},
    target,
    text,
    textClassName,
    to,
  },
) => (
  <a
    aria-label={ariaLabel}
    className={`${className} ${classNameCustom} ${disabled ? 'disabled' : ''}`}
    href={to}
    onClick={onClick}
    rel='noopener noreferrer'
    style={style}
    target={target}
  >
    {icon}
    {text && <span className={textClassName || 'button__text'}>{text}</span>}
    {children}
  </a>
);

ButtonDefaultLink.defaultProps = {
  ariaLabel: '',
  className: 'button',
  classNameCustom: '',
  disabled: false,
  icon: null,
  onClick: () => {},
  target: '_blank',
  text: null,
  textClassName: '',
};

ButtonDefaultLink.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  classNameCustom: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  target: PropTypes.string,
  text: PropTypes.string,
  textClassName: PropTypes.string,
  to: PropTypes.string.isRequired,
};

export default ButtonDefaultLink;
